var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"closedDisplay"},[_c('img',{attrs:{"src":require("@/assets/top_title.png"),"alt":""}}),_c('h2',[_vm._v("ただいま"+_vm._s(this.counterTitle != "" ? this.counterTitle + "は" : "")+"受付時間外です。")]),_c('p',[_vm._v("受付時間は平日の8時30～17:15となります。")]),_c('p',[_vm._v("受付時間内に再度アクセスしてください。")]),_c('p',[_vm._v("※繫忙時期の休日開庁日は除く")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }